import { fazendaCertificadoService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const fazendaCertificadoAction = {
    getFazendaCertificadoByIdFazenda,
    getFazendaCertificadoById,
    getCertificadosAVencer,
    onChangeProps,
    editFazendaCertificadoInfo,
    createFazendaCertificado,
    deleteFazendaCertificadoById,
    clear,
    clearChave
};
function getFazendaCertificadoByIdFazenda(idFazenda, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasCertificados/fazenda/' + idFazenda;

        fazendaCertificadoService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeFazendaCertificadosList(response.data));
                    if (showWaiting) {
                        alerts.clean();
                    }
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function getFazendaCertificadoById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasCertificados/' + id;
        fazendaCertificadoService.get(apiEndpoint)
            .then((response) => {
                dispatch(editFazendaCertificadosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}

function getCertificadosAVencer(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasCertificados/certificadosAVencer';
        fazendaCertificadoService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeFazendaCertificadosList(response.data));
                    if (showWaiting) {
                        alerts.clean();
                    }
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function createFazendaCertificado(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasCertificados/';
        fazendaCertificadoService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    dispatch(clearChave());
                    alerts.success(ret.message);
                    dispatch(getFazendaCertificadoByIdFazenda(payload.id_fazenda))
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

function editFazendaCertificadoInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendasCertificados/' + id;
        fazendaCertificadoService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    dispatch(clearChave());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message);
                    dispatch(getFazendaCertificadoByIdFazenda(payload.id_fazenda))
                } else {
                    alerts.warning(response.data.Message);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}
function deleteFazendaCertificadoById(id, id_fazenda, showWaiting) {
    return dispatch => {
        // if (showWaiting) {
        //     alerts.waiting();
        // }
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o certificado?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {
                    let apiEndpoint = 'fazendasCertificados/delete/' + id
                    fazendaCertificadoService.put(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(updatedUserInfo());
                                dispatch(clear());
                                if (showWaiting) {
                                    alerts.clean();
                                }
                                alerts.success(ret.message);
                                dispatch(getFazendaCertificadoByIdFazenda(id_fazenda));
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })
                }
            });
    }
}
export function changeFazendaCertificadosList(fazendaCertificado) {
    return {
        type: "FETECHED_ALL_FAZENDA_CERTIFICADO",
        fazendaCertificado: fazendaCertificado
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editFazendaCertificadosDetails(fazendaCertificado) {

    return {
        type: "FAZENDA_CERTIFICADO_DETAIL",
        id: fazendaCertificado.id,
        data_cadastro: fazendaCertificado.data_cadastro,
        usuario_cadastro: fazendaCertificado.usuario_cadastro,
        data_exclusao: fazendaCertificado.data_exclusao,
        usuario_exclusao: fazendaCertificado.usuario_exclusao,
        id_fazenda: fazendaCertificado.id_fazenda,
        chave: fazendaCertificado.chave,
        nome: fazendaCertificado.nome,
        data_validade: fazendaCertificado.data_validade,
        senha: fazendaCertificado.senha,
        caminho_certificado: fazendaCertificado.caminho_certificado
    }
}
export function updatedUserInfo() {
    return {
        type: "FAZENDA_CERTIFICADO_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "FAZENDA_CERTIFICADO_CREATED_SUCCESSFULLY"
    }
}
export function deleteFazendaCertificadosDetails() {
    return {
        type: "DELETED_FAZENDA_CERTIFICADO_DETAILS"
    }
}
export function clear() {
    return {
        type: "FAZENDA_CERTIFICADO_CLEAR"
    };
}

export function clearChave() {
    return {
        type: "FAZENDA_CERTIFICADO_CHAVE_CLEAR"
    };
}